import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import { Content } from "../../../_metronic/layout/components/Content";
import Toolbar from "./Toolbar";
import UserPassword from "./UserPassword";
import AccountInformation from "./AccountInformation";
import PaymentInformation from "./PaymentInformation";

const UserModule = () => {
    useEffect(() => {
        document.documentElement.classList.add("specific-account-root");
        document.body.classList.add("specific-account-root");

        return () => {
            document.documentElement.classList.remove("specific-account-root");
            document.body.classList.remove("specific-account-root");
        };
    }, []);

    return (
        <>
        {/*<PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>*/}
        <div id='kt_content' className='p-0 content d-flex flex-column flex-column-fluid specific-account-page'>
            <Toolbar />
            <div className='post d-flex flex-column-fluid specific-account-page__post' id='kt_post'>
                <Content>
                    <div className="specific-account-page__content">
                        <Routes>
                            <Route path="/password" element={<UserPassword />} />
                            <Route path="/payment" element={<PaymentInformation />} />
                            <Route path="/*" element={<AccountInformation />} />
                        </Routes>
                    </div>
                </Content>
            </div>
        </div>
        </>
    );
};

export { UserModule };
